export default __webpack_public_path__ + "static/media/Shah-Nawaz-Khan.85de7be5.jpg";